import { ErrorButtonHandler } from "../../utils/ErrorButtonHandler";

const initState = {
  message: null,
  buttons: [new ErrorButtonHandler()],
};
const reducerActions = {
  toggle(state, payload) {
    return {
      message: payload.message,
      buttons: payload.buttons,
    };
  },
  clear(state, payload) {
    return initState;
  },
};

export const modal = {
  state: initState,
  reducers: reducerActions,
};
